module.exports = __webpack_public_path__ + "1c4422b5ed505413a19f0cbaa3a7d409.png";